export const language: any = {
  title: "Ingrédients",
  select_all: "Tout sélectionner",
  deselect_all: "Tout désélectionner",
  add: "Ajouter des ingrédients",
  add_title: "Veuillez choisir comment ajouter les ingrédients.",
  add_by_list: "Ajouter des ingrédients",
  add_total: "Ajouter un total de {number} ingrédients",
  selecting: "Total des ingrédients",
  filter_title: "Trier la sélection",
  filter_newest: "Les plus récents",
  filter_oldest: "Les plus anciens",
  filter_alphabet: "Ordre alphabétique",
  get_recipe: "Obtenir des recommandations de recettes IA",
  search_placeholder: "Veuillez entrer votre terme de recherche.",
  nodata: "Aucun ingrédient disponible.",
  request: "Ajouter des ingrédients",
  recipe_title: "Plats recommandés",
  option: {
    title: "Sélectionner une option",
    desc: "La sélection d'une option n'est pas obligatoire.",
    complete: "Terminer",
    reset: "Réinitialiser"
  },
  msg: {
    msg_7: "Souhaitez-vous ajouter les ingrédients sélectionnés ?",
    msg_8: `
      <p>Souhaitez-vous ajouter les ingrédients sélectionnés ?</p>
      <p class="text-[11px] font-normal">(<span class="text-primary">{name}</span> sont exclus car ils sont déjà inclus dans les ingrédients existants.)</p>
    `,
    msg_9: "Souhaitez-vous ajouter les ingrédients sélectionnés à votre panier ?",
    msg_10: `
      <p>Souhaitez-vous ajouter les ingrédients sélectionnés à votre panier ?<br />
      <p class="text-[11px] font-normal">(<span class="text-primary">{name}</span> sont exclus car ils sont déjà inclus dans les ingrédients existants.)</p>
    `,
    confirm: "Ajouter",
    cancel: "Annuler",
    not_ingredient: "Il semble que le contenu saisi ne soit pas un ingrédient de cuisine.<br />Veuillez vérifier à nouveau.",
    ai_failed: "Une erreur est survenue lors de l'entrée de l'ingrédient.<br />Veuillez réessayer plus tard.",
    ingredient_exist_should_exclued: `(<span class="text-primary">{name}</span> sont exclus car ils sont déjà inclus dans les ingrédients existants.)`
  },
  history: "Historique de l'analyse d'image",
  myIngredient: "Mes ingrédients",
  history_no_data: "Aucun historique disponible",
  history_take_photo: "Prendre ou choisir une photo"
}
